export default __webpack_public_path__ + "static/media/freelanceImg.f803cf42.png";